import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
const EMPTY = Symbol();
export function createContainer(useHook) {
    const Context = React.createContext(EMPTY);
    function Provider(props) {
        const value = useHook(props.initialState);
        return _jsx(Context.Provider, { value: value, children: props.children });
    }
    function useContainer() {
        const value = React.useContext(Context);
        if (value === EMPTY) {
            throw new Error('Component must be wrapped with <Container.Provider>');
        }
        return value;
    }
    return { Provider, useContainer };
}
export function useContainer(container) {
    return container.useContainer();
}
//# sourceMappingURL=container.js.map